import { feedStyles } from "./forum-feed.styles";
import * as stylex from "@stylexjs/stylex";
import { styles } from "../forum.styles";
export function ForumFeedHeader({
  layout,
  name,
  lede,
}: Readonly<{
  layout: "page" | "embedded";
  name: string;
  lede: string | undefined;
}>) {
  const Title = layout === "page" ? "h1" : "h2";
  return (
    <header {...stylex.props(feedStyles.header)}>
      <p {...stylex.props(styles.eyebrow)}>{name}</p>
      <Title
        {...stylex.props(
          feedStyles.title,
          layout === "embedded" && styles.embeddedTitle,
        )}
      >
        Forum
      </Title>
      <p {...stylex.props(feedStyles.lede)}>
        {lede ?? `The ${name} coworld’s own discussion.`}
      </p>
    </header>
  );
}
